import React from 'react';
import { Link } from 'react-router-dom';
import { Link2, ChevronRight } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { useRelatedArticles } from '../../lib/relatedArticles';

// "You might also want to read" row shown below an Engineering Reference Series article's
// content -- category/subcategory match first, then keyword overlap, then popularity, then
// recency (see lib/relatedArticles.js for the full ranking rationale). Same treatment as
// How Does It Work?'s RelatedTopics. `current` is the full page_contents doc already fetched
// by DataDrivenArticlePage. Renders nothing while the catalog is loading or no related
// article is found.
const RelatedArticles = ({ current }) => {
  const related = useRelatedArticles(current, 3);

  if (related.length === 0) return null;

  return (
    <section className="border-t border-structure bg-aluminum" data-testid="related-articles-section">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="flex items-center gap-2 mb-6">
          <Link2 className="h-5 w-5 text-autoxium-blue" />
          <h2 className="font-chivo text-2xl font-bold uppercase tracking-tight">Related Articles</h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {related.map((article) => (
            <Link
              key={article.bareSlug}
              to={article.to}
              data-testid={`related-article-card-${article.bareSlug}`}
            >
              <Card className="technical-card h-full border-autoxium-blue/30">
                <CardContent className="p-6 flex flex-col h-full">
                  {(article.subcategory || article.category) && (
                    <Badge variant="outline" className="w-fit font-mono text-xs uppercase tracking-wider mb-4">
                      {article.subcategory || article.category}
                    </Badge>
                  )}
                  <h3 className="font-chivo text-lg font-bold mb-2 line-clamp-2">{article.title}</h3>
                  <p className="text-muted-foreground text-sm mb-4 line-clamp-3 flex-1">{article.description}</p>
                  <div className="flex items-center justify-end pt-4 border-t border-structure">
                    <ChevronRight className="h-4 w-4 text-autoxium-blue" />
                  </div>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedArticles;
